import { ConfirmationDialog } from "common/styleguide/ConfirmationDialog";
import { goalApi } from "data/resources/goals";
import { useFormatMessage } from "lib/localization";
import React, { useState } from "react";
import { defineMessages } from "react-intl";

export const COPY_CHALLENGE_MODAL = "COPY_CHALLENGE_MODAL";

const messages = defineMessages({
  body: {
    id: "CopyChallengeModal.body",
    defaultMessage:
      "Make a copy of this Challenge. This copy will not include participants or leaderboard stats from the existing Challenge.",
  },
  confirm: {
    id: "CopyChallengeModal.confirm",
    defaultMessage: "Copy Challenge",
  },
  goToCopy: {
    id: "CopyChallengeModal.goToCopy",
    defaultMessage: "Go to Copy",
  },
});

export const CopyChallengeModal = ({ goalId, onRequestClose }) => {
  const fm = useFormatMessage();
  const [request, setRequest] = useState({
    posting: false,
    success: false,
    error: false,
    copiedId: null,
  });

  const onConfirm = () => {
    if (request.posting) {
      return;
    }
    if (request.success && request.copiedId) {
      window.location = `/challenges/${request.copiedId}/overview`;
      return;
    }
    setRequest({ ...request, posting: true });

    goalApi
      .copy(goalId)
      .then((r) => {
        setRequest({
          copiedId: r.goal.id,
          posting: false,
          success: true,
          error: false,
        });
      })
      .catch(() => {
        setRequest({
          error: true,
          copiedId: null,
          success: false,
          posting: false,
        });
      });
  };

  return (
    <ConfirmationDialog
      maxWidth="600px"
      onRequestClose={onRequestClose}
      confirmText={fm(request.success ? messages.goToCopy : messages.confirm)}
      onConfirm={onConfirm}
    >
      {fm(messages.body)}
    </ConfirmationDialog>
  );
};
